import React from 'react';
import { useTranslation } from 'react-i18next';
import './CabinetHeader.css';

export const SectionHeader = ({ title, subtitle, action }) => {
  return (
    <div className="cabinet-section-header">
      <div className="header-content">
        {title && <h2 className="section-header-title">{title}</h2>}
        {subtitle && <p className="section-header-subtitle">{subtitle}</p>}
      </div>
      {action && <div className="header-action">{action}</div>}
    </div>
  );
};

export const CardHeader = ({ title, icon }) => {
  return (
    <div className="cabinet-card-header">
      {icon && <div className="card-header-icon">{icon}</div>}
      {title && <h3 className="card-header-title">{title}</h3>}
    </div>
  );
};

export default SectionHeader;

